import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedRoutingModule } from './shared-routing.module';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ToastComponent } from './components/toast/toast.component';
import { ToastService } from './services/toast.service';
import { CardComponent } from './components/card-component';
import { CoreModule } from '../core/core.module';
import { 
  LucideAngularModule, 
  X, 
  Eye, 
  EyeOff, 
  Loader2,
  Key,
  User,
  Phone,
  ChevronRight,
  ChevronLeft,
  Car,
  Calendar,
  Palette,
  MessageSquare,
  Clock,
  Info,
  Check,
  ChevronDown

} from 'lucide-angular';
import { EmployeeDialogComponent } from './components/dialog/employee-dialog/employee-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordDialogComponent } from './components/dialog/reset-password-dialog/reset-password-dialog.components';
import { AppointmentDetailDialogComponent } from './components/dialog/appointment-detail-dialog/appointment-detail-dialog.component';
import { ClickOutsideDirective } from './directive/click-outside.directive';
import { CustomerFormComponent } from './components/booking-flow-shared/customer-form.component';
import { ServiceSelectorComponent } from './components/booking-flow-shared/service-selector.component';
import { DateTimePickerComponent } from './components/booking-flow-shared/date-time-picker.component';


@NgModule({
  declarations: [
    PaginationComponent,
    ToastComponent,
    CardComponent,
    EmployeeDialogComponent,
    ResetPasswordDialogComponent,
    AppointmentDetailDialogComponent,
    ClickOutsideDirective,
    CustomerFormComponent,
    ServiceSelectorComponent,
    DateTimePickerComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    CoreModule,
    LucideAngularModule.pick({ 
      X, 
      Eye, 
      EyeOff, 
      Loader2,
      Key,
      User,
      Phone,
      Car,
      Calendar,
      ChevronDown,
      Palette,
      MessageSquare,
      Info,
      ChevronLeft,
      ChevronRight,
      Clock,
      Check
    }),
    ReactiveFormsModule,

  ],
  exports: [
    PaginationComponent,
    ToastComponent,
    CardComponent,
    CustomerFormComponent,
    ServiceSelectorComponent,
    DateTimePickerComponent
  ],
  providers: [
    ToastService
  ]
})
export class SharedModule { }
